import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { CLUB_SUBSCRIPTION_ROUTE } from '../constants/routes'

const WithSubscription = ({ club, children }) => {
  const history = useHistory()

  const hasValidSubscription = club.subscriptions.some((subscription) => subscription.valid)

  if (!hasValidSubscription) {
    history.push(
      CLUB_SUBSCRIPTION_ROUTE.populateURLParams({
        clubUuid: club.uuid,
      })
    )

    return null
  }

  return children
}

WithSubscription.propTypes = {
  club: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    subscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        valid: PropTypes.bool.isRequired,
      })
    ).isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.node.isRequired,
  ]).isRequired,
}

export default connect(({ clubs }) => ({
  club: clubs.current,
}))(WithSubscription)
